import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { QueryBuilderConfig } from 'ng-query-builder';
import { Subject } from 'rxjs';

import { Entity } from '../../models/entity.class';
import { SearchService } from '../../services/search/search.service';

@Component({
    selector: 'app-entity-search',
    templateUrl: './entity-search.component.html',
    styleUrls: ['./entity-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class EntitySearchComponent implements AfterViewInit, OnChanges {
    constructor(private _libSearch: SearchService) {}

    @Input() needEntityStructure: boolean;
    @Input() queryBuilderShouldVisible: boolean;
    @Input() entityClicked: boolean;
    @Input() searchQuery: {
        condition: string;
        rules: any[];
    };
    @Input() sortQuery: {
        condition: string;
        rules: any[];
    };
    @Input() searchConfig: QueryBuilderConfig;
    @Input() sortConfig: QueryBuilderConfig;
    @Input() origin: string;
    @Input() isSortConfigEmpty: boolean;
    @Input() entities: Entity | Entity[];
    @Input() selectedSearchEntity: Entity;
    @Input() isSubEntityVisible: boolean[];
    @Input() allowRuleset: boolean;
    @Input() isAddRuleVisible: boolean;
    @Input() triggerOrigin: string;
    @Input() allowCollapse: boolean;
    @Input() queryConfigChange: Subject<{
        searchConfig?: QueryBuilderConfig;
        sortConfig?: QueryBuilderConfig;
    }>;
    @Input() disabled: boolean;

    @Output() searchQueryChanged = new EventEmitter();
    @Output() sortQueryChanged = new EventEmitter();
    @Output() entityChange = new EventEmitter();

    ngAfterViewInit(): void {
        const allowedOrigins = ['revealFilters', 'editSaveFilter'];
        if (this.triggerOrigin && allowedOrigins.includes(this.triggerOrigin)) {
            this.origin !== 'ENCOLLAB' && this.toggleEntities();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            (changes.triggerOrigin && changes.triggerOrigin.currentValue) ||
            (changes.selectedSearchEntity?.firstChange && !changes.selectedSearchEntity?.previousValue) ||
            changes.selectedSearchEntity?.currentValue !== changes.selectedSearchEntity?.previousValue ||
            changes.selectedSearchEntity?.currentValue?.uid !== changes.selectedSearchEntity?.previousValue.uid
        ) {
            if (
                changes.triggerOrigin?.currentValue === 'revealFilters' ||
                changes.selectedSearchEntity?.currentValue?.uid !==
                    (changes.selectedSearchEntity?.previousValue && changes.selectedSearchEntity?.previousValue?.uid)
            ) {
                this.toggleEntities();
            }
        }
    }

    getRadioOption(entity: Entity) {
        return {
            value: entity,
            name: entity.uid,
            title: entity.displayName || entity.name,
            displayName: entity.displayName || entity.name,
        };
    }

    toggleEntities = () => {
        this._libSearch.toggle(Array.isArray(this.entities) ? this.entities : [this.entities], this.selectedSearchEntity, this.origin);
    };

    trackByIndexMethod(index: number): any {
        return index;
    }
}
